seedWebApp.controller('PricesModalCtrl', ['$scope', '$uibModalInstance', 'PricesService', 'TranslationService', 'materialID', 'ToastService',
    function PricesModalCtrl($scope, $uibModalInstance, PricesService, TranslationService, materialID, ToastService) {

        $scope.items = [{}];
        $scope.translation = TranslationService.getActiveTranslation();

        if (materialID) {
            PricesService.getPrices('', [], 0, 9999, { column: '', reverse: false }, materialID).then(function (result) {
                $scope.items = result.data;
            });
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {

            $scope.loading = true;
            var toastID = ToastService.createToast($scope.translation.SavingLoad, '', 0, 'wait');

            PricesService.savePrices($scope.items).then(
                function () {

                    $scope.loading = false;

                    ToastService.updateToast(toastID, $scope.translation.ActionSuccessfullySaved, '', 4000, 'success');
                    $uibModalInstance.close();
                },
                function (error) {

                    $scope.loading = false;

                    console.log('savePrice error: ');
                    console.log(error.data);

                    var errorMsg = error.data.Message;
                    var errorExc = error.data.ExceptionMessage;
                    ToastService.updateToast(toastID, $scope.translation.ErrorSaving, '', 4000, 'error');
                }
            );
        };

    }]
);

